import { fetcher } from '@commenda/utils';
import { UserEntityLinkRole } from '@prisma/client';

export async function assignMemberToAffiliateFirmClient(
  affiliateFirmId: string,
  companyId: number,
  userId: string,
  role: UserEntityLinkRole
) {
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/clients/${companyId}/member/${userId}?role=${role}`,
    {
      method: 'POST',
    }
  );

  return response;
}
